import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';

import { TranslatedCopy } from '../../intl/TranslatedCopy';

import { Button } from '../../components/';
import AddressBookContent from '../../addressBook/AddressBookContent';

import { sidebarOpen } from '../../addressBook/selectors';
import { billableSapAddress, compSapAddress, oneTimeAddress } from '../../checkout/reducer';

import { addressTypes } from '../../types/address';

class OrderReturnsAddressBook extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedAddress: null
    };
  }

  setSelectedAddress = address => {
    this.setState({
      selectedAddress: address
    });
  };

  setAddress = () => {
    const { shipToAddress } = this.props;
    const { selectedAddress } = this.state;
    shipToAddress(selectedAddress);
  };

  render() {
    const {
      addresses,
      sapAddresses,
      fetchAddresses,
      billableSapAddress,
      compSapAddress,
      oneTimeAddress,
      sidebarOpen,
      shipToId
    } = this.props;
    return (
      <div
        className={classnames('addressbook__main_outer orderReturns__address_modal pt5-sm', {
          sidebarOpen: sidebarOpen
        })}
      >
        <AddressBookContent
          isCheckout
          isDirectShip={false}
          addresses={addresses}
          sapAddresses={sapAddresses}
          shipToAddress={this.setSelectedAddress}
          fetchAddresses={fetchAddresses}
          shipToId={shipToId}
        />
        <div className={classnames('button-container border-top', { hidden: sidebarOpen })}>
          <Button
            type='button'
            onClick={this.setAddress}
            extraClassName={classnames('pt2-sm pr5-sm pb2-sm pl5-sm full-width ncss-btn-primary-dark', {
              'button-edit': billableSapAddress || compSapAddress || oneTimeAddress
            })}
            data-desc='orderReturnsAddressBook__button_submit'
          >
            <TranslatedCopy id='orderreturns.setReturnAddress' />
          </Button>
        </div>
      </div>
    );
  }
}

OrderReturnsAddressBook.defaultProps = {
  addresses: null,
  billableSapAddress: null,
  compSapAddress: null,
  oneTimeAddress: null,
  sapAddresses: null,
  shipToAddress: null
};

OrderReturnsAddressBook.propTypes = {
  addresses: PropTypes.arrayOf(PropTypes.shape(addressTypes)),
  billableSapAddress: PropTypes.shape(addressTypes),
  compSapAddress: PropTypes.shape(addressTypes),
  fetchAddresses: PropTypes.func.isRequired,
  oneTimeAddress: PropTypes.shape(addressTypes),
  sapAddresses: PropTypes.arrayOf(PropTypes.shape(addressTypes)),
  shipToAddress: PropTypes.func,
  sidebarOpen: PropTypes.bool.isRequired,
  shipToId: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  billableSapAddress: billableSapAddress(state),
  compSapAddress: compSapAddress(state),
  oneTimeAddress: oneTimeAddress(state),
  sidebarOpen: sidebarOpen(state)
});

const connector = connect(mapStateToProps, {});

export default connector(OrderReturnsAddressBook);
